<template>
  <main class="secondary_bg_color" style="height: 80vh">
    <div class="m-auto h-100">
      <img class="w-100 h-100" src="../assets/devotional1.jpeg" alt="">
    </div>
  </main>
</template>
